import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';

const AdminMenu = () => {
  
  return (
    <div className="text-center">
        <h1>Este es el menú de administrador</h1>
        <h2 className="text-center mb-4">Opciones de Administración</h2>
        <ul className="list-group">
            <li className="list-group-item-admin">
              <a href="/service-types-editor">Editar Tipos de Servicios</a>
            </li>
            <li className="list-group-item-admin">
              <a href="/service-editor">Editar Servicios</a>
            </li>
            <li className="list-group-item-admin">
              <a href="/blog-editor">Editar Blog</a>
            </li>
        </ul>
    </div>
  )
}

export default AdminMenu
